{
    "chooseDevice": {
        "brand": "Бренд",
        "category": "Категория",
        "color": "Цвет",
        "cpu": "Процессор",
        "deviceNotAccepted": "К сожалению данное устройство не принимается",
        "gpu": "Видеокарта",
        "memory": "Накопитель",
        "model": "Модель",
        "other": "Память / Модель / Год",
        "ram": "Оперативная память",
        "subtitle": "Укажите модель, чтобы узнать размер скидки",
        "title": "Какое устройство вы хотите сдать?"
    },
    "common": {
        "back": "Вернуться",
        "close": "Закрыть",
        "continue": "Продолжить",
        "error": "Что-то пошло не так. Попробуйте ещё раз.",
        "restart": "Начать заново"
    },
    "grades": {
        "A": "Отличное",
        "B": "Хорошее",
        "C": "Со следами эксплуатации",
        "D": "Со значительными следами эксплуатации",
        "E": "Критическое",
        "Q": "Идеальное"
    },
    "handedDevice": {
        "edit": "Изменить устройство",
        "title": "Сдаваемое устройство",
        "valuation": "Оценка устройства"
    },
    "leaveContacts": {
        "priceNote": "Цены действительны 14 рабочих дней, а окончательная цена выкупа будет известна только после физической диагностики.",
        "title": "Предварительная цена"
    },
    "requestBuyoutOffer": {
        "companyName": "Название компании",
        "consent": "Я соглашаюсь на обработку моих персональных данных согласно {link}",
        "consentLink": "Закону Украины «О защите персональных данных»",
        "email": "Email",
        "emailInvalid": "Укажите корректный email",
        "firstName": "Имя",
        "lastName": "Фамилия",
        "optional": "необязательно",
        "phone": "Телефон",
        "phoneInvalid": "Укажите номер с кодом страны, от 9 до 15 цифр",
        "subtitle": "Оставьте контакты, чтобы наш менеджер мог подготовить для вас предложение по выкупу",
        "title": "Узнайте, сколько стоит вся техника вашей компании"
    },
    "select": {
        "notFound": "Извините. Совпадений не найдено."
    },
    "thanksForOrder": {
        "sendAnother": "Отправить ещё один запрос",
        "text": "Наш менеджер рассчитает стоимость техники и свяжется с вами. Спасибо, что продлеваете жизнь технике! ☘️",
        "title": "Готово! Ваш запрос отправлен."
    },
    "uploadDevicesList": {
        "chooseFile": "Загрузите файл",
        "downloadTemplate": "Скачать шаблон списка устройств",
        "dropHere": "Перетащите файл сюда",
        "invalidFormat": "Поддерживается только формат XLSX",
        "or": "или",
        "removeFile": "Удалить файл",
        "submit": "Получить предложение по выкупу",
        "subtitle": "Загрузите файл со списком устройств в формате XLSX или используйте шаблон для заполнения",
        "title": "Загрузите список устройств для проверки"
    }
}
